import React, {useState} from 'react'
import {makeStyles, Table, TableBody, TableCell, TableHead, TableRow} from '@material-ui/core';
import Tr from 'translations/Translations';
import EditDescriptionPopup, {createEditDescriptionFile} from "components/popup/EditDescriptionPopup";
import GeneralInfoDocumentsFileTableRow from "./GeneralInfoDocumentsFileTableRow";
import BoldTypography from "components/BoldTypography";
import PropTypes from 'prop-types';
import WorkableIconDownloadButton from "components/button/WorkableIconDownloadButton";
import DemandOffersGeneralInfoService from "services/DemandOffersGeneralInfoService";

const useStyle = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    lpColumn: theme.components.table.lpColumn,
    buttonColumn: theme.components.table.buttonColumn,
    dateColumn: theme.components.table.dateColumn,
}));

function GeneralInfoDocumentsFileTable(
    {
        demandId,
        stageId,
        supplierId,
        generalInfoDocuments,
    }) {

    const classes = useStyle();
    const [downloadZipWorking, setDownloadZipWorking] = useState(false);
    const [editDescriptionFile, setEditDescriptionFile] = useState(null);

    const openEditDescription = (row) => {
        setEditDescriptionFile(createEditDescriptionFile(demandId, row.identity, row.name, row.description, true));
    };

    return (<div className={classes.root}>
        {!generalInfoDocuments.length ?
            <BoldTypography align='center' variant="h6">{Tr('no_options')}</BoldTypography>
            :
            <>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.lpColumn}>{Tr("column_lp")}</TableCell>
                            <TableCell>{Tr("name")}</TableCell>
                            <TableCell className={classes.buttonColumn}>{Tr("description")}</TableCell>
                            <TableCell className={classes.dateColumn}>{Tr("publish_data")}</TableCell>
                            <TableCell className={classes.buttonColumn}>
                                <WorkableIconDownloadButton
                                    tooltip={Tr('download_all_files_compressed')}
                                    working={downloadZipWorking}
                                    onClick={() => {
                                        setDownloadZipWorking(true);
                                        DemandOffersGeneralInfoService.downloadContractorGeneralInfoDocumentsZip(demandId, stageId, supplierId, () => {
                                            setDownloadZipWorking(false);
                                        })
                                    }
                                    }
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            generalInfoDocuments.map((doc, index) => (
                                <GeneralInfoDocumentsFileTableRow
                                    key={doc.source + "_" + doc.identity}
                                    demandId={demandId}
                                    stageId={stageId}
                                    supplierId={supplierId}
                                    row={doc}
                                    index={index + 1}
                                    onEditDescriptionFile={openEditDescription}
                                />))
                        }
                    </TableBody>
                </Table>
            </>
        }
        {Boolean(editDescriptionFile) &&
            <EditDescriptionPopup
                editDescriptionFile={editDescriptionFile}
                onUpdated={() => setEditDescriptionFile(null)}
                onClose={() => setEditDescriptionFile(null)}
                service={{
                    updateDescription: () => {
                    }
                }}
            />
        }
    </div>)
}

GeneralInfoDocumentsFileTable.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    stageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
export default GeneralInfoDocumentsFileTable;